import { render, staticRenderFns } from "./SmallUserPreview.vue?vue&type=template&id=0db3168f&scoped=true&lang=pug&"
import script from "./SmallUserPreview.vue?vue&type=script&lang=js&"
export * from "./SmallUserPreview.vue?vue&type=script&lang=js&"
import style0 from "./SmallUserPreview.vue?vue&type=style&index=0&id=0db3168f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3168f",
  null
  
)

export default component.exports